<template>
    <td-dialog
        :title="title"
        :before-close="uploadExcelDialogClose"
        :visible.sync="dialogUploadExcelVisible"
        width="32%"
        append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formUploadExcelInfo" ref="formUploadExcelInfo" :rules="rules">
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <!-- <td-upload  :actionUrl="actionUrl" ref="upload" :autoUpload="true" showFileList="true" accept="xls/xlsx" :limit="1" :multiple="false"
                            :message="$t('common.UPLOAD_EXCEL_MESSAGE')" @handleRemove="handleRemove"></td-upload> -->
                        <td-upload
                            actionUrl="/auth/user/uploadFile"
                            ref="upload"
                            :message="$t('message.UPLOAD_USER_EXCEL')"
                            :multiple="false"
                            :showFileList="true"
                            :on-error="handResponse"
                            :on-success="handResponse"
                            accept="csv"
                            limitSize="10240"
                        ></td-upload>
                        <!-- <el-upload
                        class="upload-demo"
                        action="https://127.0.0.1:7000/user/readExcel"
                        multiple
                        :limit="1"
                        :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload> -->
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="button" @click.native="uploadExcelDialogClose">{{ $t('common.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogUploadExcelVisible'],
    created() {},
    // 定义变量
    data() {
        return {
            // UploadExcel表单信息
            formUploadExcelInfo: {
                sId: '',
                sName: '',
                iOrder: '',
                sSysFlg: ''
            },
            formLabelWidth: '30%',
            actionUrl: '/user/readExcel',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.error_caption_max_length'), trigger: 'blur' },
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_CAPTION_ILLEGAL')
                    }
                ],
                iOrder: [
                    { required: true, message: this.$t('error.ERROR_ORDER_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.ORDER_RULE,
                        message: this.$t('error.ERROR_ORDER_ILLEGAL')
                    }
                ]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            // this.formUploadExcelInfo.sName = this.uploadExcelItem.sUploadExcelName
            // this.formUploadExcelInfo.sId = this.uploadExcelItem.sId
            // this.formUploadExcelInfo.iOrder = this.uploadExcelItem.iOrder
        },
        // 提交数据
        submitForm(formName) {
            this.$refs.upload.submitUpload();
            // this.$emit('getCheckedOrgList', this.$refs.tree.getCheckedNodes())
            this.$emit('uploadExcelDialogClose');
        },
        handResponse(response, file, fileList) {
            if (response.statusCode === this.$common.requestCode.USER_EXIST) {
                let msg = this.$t('common.UPLOADSUCESSE') + (response.count - response.content.length) + this.$t('common.USER');
                let arr = response.content;
                let users = '';
                for (let index = 0; index < arr.length; index++) {
                    const element = arr[index];
                    if (index >= 3) {
                        users += this.$t('common.ETC');
                        break;
                    }
                    if (index === 0) {
                        users = element.sName;
                    } else {
                        users += '、' + element.sName;
                    }
                }
                msg += ' , ' + this.$t('common.REPEAT') + response.content.length + this.$t('common.USER') + ' : ' + users;
                this.$message({ showClose: true, message: msg, type: 'warning' });
                return;
            }
            if (response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.statusMessage, type: 'error' });
                this.$log.error('/auth/user/uploadFile', response.statusMessage);
                return;
            }
            this.$message({ showClose: true, message: this.$t('common.UPLOADSUCESSE'), type: 'success' });
        },
        // 关闭窗口之前需要调用的方法
        uploadExcelDialogClose() {
            this.$emit('uploadExcelDialogClose');
            // this.$emit('submit')
            this.$refs['formUploadExcelInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
